module.exports = __webpack_public_path__ + "svg/new-collector.4d6affe684d1083d01f4ea331992ab2a.svg";